import { useTheme } from "styled-components";

// types
import { BackgroundColor } from "./online-catalog-assets.types";

// utils
import { useThemeName } from "utils/hooks/use-theme";

export const useThemedBackgroundColor = (backgroundColor: BackgroundColor) => {
  const theme = useTheme();
  const themeName = useThemeName();

  switch (backgroundColor) {
    case 'porcelain': {
      if (themeName === 'NORD') {
        return '#f1f2f2';
      }
      return '#f1f1f1';
    }
    case 'medium-grey':
      return '#e3e3e3';
    case 'white':
      return theme.colors.white ?? '#fff';
    default:
      return '#f1f2f2';
  }
};
